import React from 'react';
import eventTimeConversion from './eventTimeConversion';
import { isValid } from './validate';

const TimeForCarouselTiles = (event) => {

  if(String(event.event.datetimeLocal).split(' ')[4]==='00:00:00') {
    return (null);
  } else {
    return(
      <strong className='hti-time'>
        {isValid(event.event.datetimeUTC) ?
          eventTimeConversion(event.event.datetimeUTC):
        null}
      </strong>
    )
  }
};

const TimeForPopUp = (event) => {
  if(String(event.event.datetimeLocal).split(' ')[4]==='00:00:00') {
    return (null);
  } else {
    return(
        isValid(event.event.datetimeUTC) ?
          ', '+eventTimeConversion(event.event.datetimeUTC):
        null
    )
  }
};

export {TimeForCarouselTiles, TimeForPopUp};